export const sessionKeys = { refresh: 'refresh_token', access: 'access_token', user: 'auth_user_cache' };

export function isSessionRejected(error) {
  return error?.status === 401 || (error?.status === 403 && ['BLOCKED', 'PENDING_APPROVAL'].includes(error?.code));
}

export function readStoredSession(storage) {
  try {
    const accessToken = storage.getItem(sessionKeys.access);
    const refreshToken = storage.getItem(sessionKeys.refresh);
    const user = JSON.parse(storage.getItem(sessionKeys.user) || 'null');
    return accessToken && refreshToken && user ? { accessToken, refreshToken, user } : null;
  } catch { return null; }
}

// Web Locks serialize rotation across tabs sharing the same origin/storage.
export async function refreshStoredSession({ storage, locks, request }) {
  const observed = storage.getItem(sessionKeys.refresh);
  const run = async () => {
    const token = storage.getItem(sessionKeys.refresh);
    if (!token) return null;
    if (token !== observed) return readStoredSession(storage);
    let data;
    try { data = await request(token); }
    catch (error) {
      if (storage.getItem(sessionKeys.refresh) !== token) return readStoredSession(storage);
      throw error;
    }
    // A logout or another login while the request was in flight wins.
    if (storage.getItem(sessionKeys.refresh) !== token) return readStoredSession(storage);
    storage.setItem(sessionKeys.access, data.accessToken);
    storage.setItem(sessionKeys.user, JSON.stringify(data.user));
    storage.setItem(sessionKeys.refresh, data.refreshToken);
    return data;
  };
  return locks ? locks.request('warehouse-hub-session-refresh', run) : run();
}
